export const GET_OBJECT_RELATED_OBJECTS_SUCCESS = 'GET_OBJECT_RELATED_OBJECTS_SUCCESS';
export const GET_OBJECT_TABS_TO_DISPLAY = 'GET_OBJECT_TABS_TO_DISPLAY';
export const SET_OBJECT_TYPE_IDENTIFIER = 'SET_OBJECT_TYPE_IDENTIFIER';
export const GET_OBJECT_PROPERTIES_SUCCESS = 'GET_OBJECT_PROPERTIES_SUCCESS';
export const GET_STATIC_ANALYSIS_SUCCESS = 'GET_STATIC_ANALYSIS_SUCCESS';
export const DISPATH_SELECTED_ROWS = 'DISPATH_SELECTED_ROWS';
export const DISPATH_SELECTED_TAB = 'DISPATH_SELECTED_TAB';
export const GET_OBJECT_RELATED_INFORMATION_SUCCESS = 'GET_OBJECT_RELATED_INFORMATION_SUCCESS';
export const GET_REMOTE_IPS_SUCCESS = 'GET_REMOTE_IPS_SUCCESS';
export const CHANGE_POLICY_STATUS_SUCCESS = 'CHANGE_POLICY_STATUS_SUCCESS';
export const DISPATH_SELECTED_ALERT_ROWS = 'DISPATH_SELECTED_ALERT_ROWS';
export const DISPATH_SELECTED_ALERT_NEW_STATUS = 'DISPATH_SELECTED_ALERT_NEW_STATUS';
export const SAVE_FILE_GLOBAL_STATE = 'SAVE_FILE_GLOBAL_STATE';
export const SET_CHECKBOX_SEARCH_TABLE_DATA = 'SET_CHECKBOX_SEARCH_TABLE_DATA';
